export default "__VITE_ASSET__Dlv1awgS__"